import {buildAsyncActionsCreator, createAsyncActionExecutor} from '../asyncUtils';
import {VeevaActions} from './types';
import {requestVeevaDocMetadata, requestVeevaMdpList, requestVeevaMdpModelLanguage, requestVeevaVeap} from './api';

const veevaLoadMdpModelLanguageActionsCreator = buildAsyncActionsCreator(VeevaActions.REQUEST_MDP_MODEL_LANGUAGE);
export const veevaLoadMdpModelLanguage = createAsyncActionExecutor(
  veevaLoadMdpModelLanguageActionsCreator,
  requestVeevaMdpModelLanguage,
);

const veevaLoadVeapActionsCreator = buildAsyncActionsCreator(VeevaActions.REQUEST_VEAP);
export const veevaLoadVeap = createAsyncActionExecutor(veevaLoadVeapActionsCreator, requestVeevaVeap);

const veevaLoadMdpListActionsCreator = buildAsyncActionsCreator(VeevaActions.REQUEST_MDP_LIST);
export const veevaLoadMdpList = createAsyncActionExecutor(veevaLoadMdpListActionsCreator, requestVeevaMdpList);

const veevaLoadDocMetadataActionsCreator = buildAsyncActionsCreator(VeevaActions.REQUEST_DOC_METADATA);
export const veevaLoadDocMetadata = createAsyncActionExecutor(
  veevaLoadDocMetadataActionsCreator,
  requestVeevaDocMetadata,
);
